<main
  class="funnel-main"
  [ngClass]="{ 'activate-theme': isActivateRedirect() }"
>
  <flo-coupon-status [couponHasBeenApplied]="isCouponApplied$ | async"></flo-coupon-status>
  <section>
    <router-outlet></router-outlet>
  </section>
</main>
